/* eslint-disable import/first */
import type { ReactNode, ReactElement } from 'react';

// @mui
import { InputAdornment, ClickAwayListener, TextField } from '@mui/material';
// components
import { Icon as Iconify } from '@iconify/react';
import { useTranslation } from 'react-i18next';

const IconifyComponent = Iconify as any;

export interface ChatNavSearchProps {
  value?: string;
  onChange?: (...args: any[]) => any;
  onClickAway?: (...args: any[]) => any;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function ChatNavSearch({
  value,
  onChange,
  onClickAway,
}: ChatNavSearchProps) {
  const { t } = useTranslation('translation');
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={onChange}
        placeholder={t('chat.search-conversation')}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <IconifyComponent
                  icon="eva:search-fill"
                  sx={{ color: 'text.disabled' }}
                />
              </InputAdornment>
            ),
          },
        }}
        sx={{ mt: 2.5 }}
      />
    </ClickAwayListener>
  );
}
